import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { refreshMe } = useApp();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = location.hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/"); return; }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        // Also store as bearer for parallel JWT flow
        localStorage.setItem("gg_token", data.session_token);
        await refreshMe();
        window.history.replaceState(null, "", "/");
        toast.success("Signed in");
        const nx = sessionStorage.getItem("gg_next"); sessionStorage.removeItem("gg_next"); nav(nx || "/");
      } catch (e) {
        toast.error("Sign-in failed");
        nav("/auth");
      }
    })();
  }, [location.hash, nav, refreshMe]);

  return <div className="max-w-md mx-auto p-10 text-center eyebrow">Signing you in…</div>;
}
